import { useState } from 'react'

import { RequestProfileTabEmailsSummaryExpandContext } from '../RequestProfileTabEmails.contexts'

// Remembers manually collapsed thread-summary widgets per thread uuid —
// mounted at the request-profile level because both widget hosts (preview
// panel, thread modal) remount per thread.
function RequestProfileTabEmailsSummaryExpandContextProvider({ children }) {
  const [collapsedThreadUuids, setCollapsedThreadUuids] = useState(
    () => new Set()
  )

  function toggleThreadSummaryExpanded(uuid, isExpanded) {
    setCollapsedThreadUuids(prev => {
      const next = new Set(prev)

      if (isExpanded) {
        next.delete(uuid)
      } else {
        next.add(uuid)
      }

      return next
    })
  }

  const value = {
    isThreadSummaryCollapsed: uuid => collapsedThreadUuids.has(uuid),
    toggleThreadSummaryExpanded,
  }

  return (
    <RequestProfileTabEmailsSummaryExpandContext value={value}>
      {children}
    </RequestProfileTabEmailsSummaryExpandContext>
  )
}

export default RequestProfileTabEmailsSummaryExpandContextProvider
